"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValidationErrors = handleValidationErrors;
var _ErrorCodeMapper = require("../models/ErrorCodeMapper");
function handleValidationErrors(errorResponse, setError, formatMessage) {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  if (!errorResponse?.errors?.length) {
    return;
  }
  errorResponse.errors.forEach(err => {
    if (err.propertyName && err.code) {
      const errorCodeData = _ErrorCodeMapper.ErrorCodeMapper.getLocalizationKey(err.code);
      const errorMessage = formatMessage(errorCodeData.id);
      setError(err.propertyName, {
        type: 'manual',
        message: errorMessage
      });
    } else if (err.code) {
      const errorCodeData = _ErrorCodeMapper.ErrorCodeMapper.getLocalizationKey(err.code);
      const errorMessage = formatMessage(errorCodeData.id);
      setError('_general', {
        type: 'manual',
        message: errorMessage
      });
    }
  });
}
